"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _EquizzerChapterCanOpenChecker = _interopRequireDefault(require("../checks/EquizzerChapterCanOpenChecker"));

var _EquizzerQuizCanOpenChecker = _interopRequireDefault(require("../checks/EquizzerQuizCanOpenChecker"));

var _EquizzerHighscoreCanOpenChecker = _interopRequireDefault(require("../checks/EquizzerHighscoreCanOpenChecker"));

var _EquizzerTournamentCanOpenChecker = _interopRequireDefault(require("../checks/EquizzerTournamentCanOpenChecker"));

var _EquizzerTrainingCanOpenChecker = _interopRequireDefault(require("../checks/EquizzerTrainingCanOpenChecker"));

var _Quiz = _interopRequireDefault(require("../Quiz"));

var _KesiConnect = _interopRequireDefault(require("../KesiConnect"));

var _QuizTraining = _interopRequireDefault(require("../QuizTraining"));

var _QuizTournament = _interopRequireDefault(require("../QuizTournament"));

var _QrReaderInEmsMainMenu = _interopRequireDefault(require("../checks/QrReaderInEmsMainMenu"));

var _QuizModeChooser = _interopRequireDefault(require("../QuizModeChooser"));

var _QdLearningContainer = _interopRequireDefault(require("../../QdLearning/containers/QdLearningContainer"));

// import QuizQuestionView from '../QuizQuestionView'
var FEATURE_NAME = 'equeoqd';
var knownCourseTypes = ['equeoqd_settings', 'equeoqd_game_v2', 'equeoqd_highscore', 'equeoqd_chapter', 'equeoqd_kesi_connect', 'equeoqd_live_editor', 'equeoqd_tournament', 'equeoqd_training', 'equeoqd_learning', 'equeoqd_question_view', 'qrreader'];
var i = 0;
var FEATURE_ROUTES = [/*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz(/:id)",
  component: _Quiz["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_new_round(/:id)",
  component: _Quiz["default"],
  page: "new_round"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_round(/:id)",
  component: _Quiz["default"],
  page: "round"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_highscore(/:id)",
  component: _Quiz["default"],
  page: "highscore"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_settings(/:id)",
  component: _Quiz["default"],
  page: "settings"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_opponents(/:id)",
  component: _Quiz["default"],
  page: "opponents"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_categories(/:id)",
  component: _Quiz["default"],
  page: "categories"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_subjects(/:id)",
  component: _Quiz["default"],
  page: "subjects"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_mode_chooser(/:id)",
  component: _QuizModeChooser["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_running(/:id)",
  component: _Quiz["default"],
  page: "running"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_round_overview(/:id)",
  component: _Quiz["default"],
  page: "overview"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_connect(/:id)",
  component: _KesiConnect["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament_start(/:id)",
  component: _QuizTournament["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz(/:id)",
  component: _Quiz["default"],
  tournamentMode: true
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_new_round(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "new_round"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_round(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "round"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_highscore(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "highscore"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_settings(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "settings"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_opponents(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "opponents"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_categories(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "categories"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_subjects(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "subjects"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_mode_chooser(/:id)",
  component: _QuizModeChooser["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_running(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "running"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_tournament/quiz_round_overview(/:id)",
  component: _Quiz["default"],
  tournamentMode: true,
  page: "overview"
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: "quiz_training(/:id)",
  component: _QuizTraining["default"]
}),
/*#__PURE__*/

/* <Route key={`Route-${FEATURE_NAME}-${i++}`} path='quiz_question_view(/:id)' component={QuizQuestionView} />, */
_react["default"].createElement(_reactRouter.Route, {
  key: "Route-".concat(FEATURE_NAME, "-").concat(i++),
  path: 'quiz_learning(/:id)',
  component: _QdLearningContainer["default"]
})]; // currently not in use
// <Route key={`Route-${FEATURE_NAME}-${i++}`} path='quiz_live_editor(/:id)' component={QuestionEditor} />,

var FEATURE_TYPE_ROUTE_MAPPING = {
  equeoqd_game_v2: '/quiz',
  equeoqd_subjects: '/equeoqd_subjects',
  equeoqd_highscore: '/quiz_highscore',
  equeoqd_settings: '/quiz_settings',
  equeoqd_kesi_connect: '/quiz_connect',
  equeoqd_live_editor: '/quiz_live_editor',
  equeoqd_tournament: '/quiz_tournament_start',
  equeoqd_training: '/quiz_training',
  equeoqd_question_view: '/quiz_question_view',
  equeoqd_learning: '/quiz_learning'
};

var getCanOpenCheckers = function getCanOpenCheckers(registerCallback) {
  // eslint-disable-next-line no-magic-numbers
  var key = 0;
  return {
    equeoqd_chapter: /*#__PURE__*/_react["default"].createElement(_EquizzerChapterCanOpenChecker["default"], {
      chapterType: "equeoqd_chapter",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    equeoqd_game_v2: /*#__PURE__*/_react["default"].createElement(_EquizzerQuizCanOpenChecker["default"], {
      chapterType: "equeoqd_game_v2",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    equeoqd_tournament: /*#__PURE__*/_react["default"].createElement(_EquizzerTournamentCanOpenChecker["default"], {
      chapterType: "equeoqd_tournament",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    equeoqd_training: /*#__PURE__*/_react["default"].createElement(_EquizzerTrainingCanOpenChecker["default"], {
      chapterType: "equeoqd_training",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    equeoqd_question_view: /*#__PURE__*/_react["default"].createElement(_EquizzerTrainingCanOpenChecker["default"], {
      chapterType: "equeoqd_question_view",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    ergoquiz_highscore: /*#__PURE__*/_react["default"].createElement(_EquizzerHighscoreCanOpenChecker["default"], {
      chapterType: "ergoquiz_highscore",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    qrreader: /*#__PURE__*/_react["default"].createElement(_QrReaderInEmsMainMenu["default"], {
      chapterType: "qrreader",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    }),
    equeoqd_learning: /*#__PURE__*/_react["default"].createElement(_EquizzerTrainingCanOpenChecker["default"], {
      chapterType: "equeoqd_learning",
      key: "eQuizzerCanOpenChecker_".concat(key++),
      registerAsCheckerComponent: registerCallback
    })
  };
};

var _default = {
  FEATURE_ROUTES: FEATURE_ROUTES,
  FEATURE_TYPE_ROUTE_MAPPING: FEATURE_TYPE_ROUTE_MAPPING,
  getCanOpenCheckers: getCanOpenCheckers,
  knownCourseTypes: knownCourseTypes,
  inheritingCourseTypes: []
};
exports["default"] = _default;